import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getModuleByIdStart } from "../../Store/Slices/formSlice";
var converter = require('number-to-words');

const PrintTemplate = ({
    showPrintPreviewModal,
    setShowPrintPreviewModal,
    templateData,
    selectedRowData
}) => {
    const dispatch = useDispatch();
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    // //console.log('current org:', currentOrg)

    let [selectedContent, setSelectedContent] = useState('');
    let [selectedTemplateIndex, setSelectedTemplateIndex] = useState('')
    let [quotesData, setQuotesData] = useState();
    let [contactsData, setContactsData] = useState();
    let [quoteLoader, setQuoteLoader] = useState(false);
    let [contactsLoader, setContactsLoader] = useState(false)
    let [fieldList, setFieldList] = useState([]);

    const changeCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    // const extractPlaceholders = (content) => {
    //     const regex = /\${QUOTES\.Item\.(\w+)}/g;
    //     const matches = [...content.matchAll(regex)]; // Extract all matches
    //     return matches.map(match => match[0]); // Return full placeholder strings
    // };

    const formatValue = (value) => {
        return typeof value === "number" ? String(value) : value;
    };

    const cleanPlaceholders = (content) => {
        return content.replace(/\${(.*?)}/g, "$1"); // Keeps the inner content but removes "${" and "}"
    };

    const replaceSubtotal = (content) => {
        content = content.replaceAll('${Sub Total}', selectedRowData?.aggregate_list?.Total)
        return content
    }

    const replaceDiscount = (content) => {
        content = content.replaceAll('${Discount}', selectedRowData?.aggregate_list?.Discount)
        return content
    }

    const replaceTax = (content) => {
        content = content.replaceAll('${Tax}', selectedRowData?.aggregate_list?.Tax)
        return content
    }

    const replaceGrandtotal = (content) => {
        content = content.replaceAll('${Grand Total}', selectedRowData?.aggregate_list?.Grant_Total)
        return content
    }

    const replaceTotalInWord = (content) => {
        content = content.replaceAll('${TotalInWords}', converter.toWords(selectedRowData?.aggregate_list?.Grant_Total))
        return content
    }

    // const extractElementByClass = (htmlString, className) => {
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(htmlString, "text/html");
    //     const targetElement = doc.getElementsByClassName(className)[0]; // Get first match
    //     //console.log('targeted element:', targetElement?.outerHTML)
    //     return targetElement ? targetElement.outerHTML : null;
    // };

    // const replaceElementByClass = (htmlString, className) => {
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(htmlString, "text/html");

    //     // Find the target element by class name
    //     const targetElement = doc.getElementsByClassName(className);
    //     debugger

    //     if (targetElement) {
    //         // Replace target element with new element
    //         if (selectedRowData?.table_data?.length > 0) {
    //             // targetElement.outerHTML = newElement;
    //         }
    //     }

    //     return doc.body.innerHTML; // Convert back to HTML string
    // };

    const replaceTableData = (content, i) => {
        const regex = /\${QUOTES\.Item\.([^}]+)}/g;
        let match; const matches = [];
        content = content.replaceAll('${QUOTES.item.S.No}', i + 1)
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[0]);
            let mt = match[0];
            mt = cleanPlaceholders(mt)
            let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
            let field = selectedField
            let type = typeof (selectedRowData?.table_data[i]?.[selectedField])
            let _field;
            if (type === 'object') {
                _field = selectedRowData?.table_data[i]?.[selectedField]['name']
            } else if (type === 'string' || type === 'number') {
                _field = selectedRowData?.table_data[i]?.[selectedField]
            }
            let _mt = '${' + mt + '}'
            _field = _field === undefined ? '-' : _field
            content = content.replaceAll(_mt, _field)
        }
        return content
    }

    const replaceElementsByClassMultipleTimes = (htmlString, className) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Find all elements with the target class name
        const targetElements = doc.getElementsByClassName(className);

        Array.from(targetElements).forEach((el) => {
            //console.log('---->', targetElements[0].outerHTML)
            let repeatedElements = "";
            for (let i = 0; i < selectedRowData?.table_data?.length; i++) {
                // repeatedElements += targetElements[0].outerHTML;
                let replacedContent = replaceTableData(targetElements[0].outerHTML, i);
                repeatedElements += replacedContent;
            }
            el.outerHTML = repeatedElements;
        });

        return doc.body.innerHTML; // Convert back to HTML string
    };

    const replacePlaceholders = (content) => {
        //console.log('SEL ROW:', selectedRowData)
        if (selectedRowData?.table_data?.length > 0) {
            // const extractedTableRow = extractElementByClass(content, 'product-item-table-row')
            const extractedTableRow = replaceElementsByClassMultipleTimes(content, 'product-item-table-row')
            content = extractedTableRow || content

            selectedRowData?.table_data?.forEach((element, index) => {
                //console.log('inx', index)
                //console.log('element:', element)

                const regex = /\${QUOTES\.Item\.([^}]+)}/g;
                let match; const matches = [];
                while ((match = regex.exec(content)) !== null) {
                    matches.push(match[0]);
                    let mt = match[0];
                    mt = cleanPlaceholders(mt)
                    let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
                    let field = selectedField
                    let type = typeof (element?.[selectedField])
                    let _field;
                    if (type === 'object') {
                        _field = element?.[selectedField]['name']
                    } else if (type === 'string' || type === 'number') {
                        _field = element?.[selectedField]
                    }
                    let _mt = '${' + mt + '}'
                    _field = _field === undefined ? '-' : _field
                    content = content.replaceAll(_mt, _field)
                }
            });
        } else {
            content = null
        }
        return content
    };

    // const replacePlaceholdersOld = (content) => {
    //     //console.log('SEL ROW:', selectedRowData)
    //     // Regex to find all placeholders in the format "${QUOTES.Item.KEY}"
    //     // const regex = /\${QUOTES\.Item\.(\w+)}/g;
    //     const regex = /\${QUOTES\.Item\.([^}]+)}/g;
    //     let match; const matches = [];
    //     while ((match = regex.exec(content)) !== null) {
    //         // debugger
    //         matches.push(match[0]);
    //         let mt = match[0];
    //         mt = cleanPlaceholders(mt)
    //         let selectedField = mt.split('.')[2]?.replaceAll(' ', '_')
    //         let field = selectedField
    //         let type = typeof (selectedRowData?.table_data?.[0]?.[selectedField])
    //         let _field;
    //         if (type === 'object') {
    //             _field = selectedRowData?.table_data?.[0]?.[selectedField]['name']
    //         } else if (type === 'string' || type === 'number') {
    //             _field = selectedRowData?.table_data?.[0]?.[selectedField]
    //         }
    //         let _mt = '${' + mt + '}'
    //         _field = _field === undefined ? '-' : _field
    //         // _field = formatValue(_field)
    //         content = content.replaceAll(_mt, _field)
    //     }
    //     // setSelectedContent(content)
    //     // //console.log('Contttt:', content)
    //     return content
    //     // const updatedContent = content;
    //     // return { updatedContent }

    //     // // Extract all matches
    //     // const _matches = [...content.matchAll(regex)];
    //     // //console.log("->", _matches)

    //     // // Replace placeholders dynamically
    //     // const updatedContent = content.replace(regex, (_, key) => data[key.split('.')[2]] || "");

    //     // return { updatedContent, placeholders: matches.map(match => match[0]) };
    // };

    const getDynamicContent = (content) => {
        const itemContent = replacePlaceholders(content);
        content = itemContent || content
        const subtotalContent = replaceSubtotal(content)
        content = subtotalContent || content
        const discountContent = replaceDiscount(content)
        content = discountContent || content
        const taxContent = replaceTax(content)
        content = taxContent || content
        const grandtotalContent = replaceGrandtotal(content)
        content = grandtotalContent || content
        const totalInWordContent = replaceTotalInWord(content)
        content = totalInWordContent || content

        const regex = /\$\{([^}]+)\}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(content)) !== null) {
            matches.push(match[1]);
            let mt = match[1];
            let key = mt.split('.')[0];
            let val = mt.split('.')[1];

            let selectedField;
            let type;
            let _field;
            if (key === 'ORGANIZATION') {
                selectedField = val
                if (val === 'Organization Name')
                    selectedField = changeCase(val)?.replaceAll(' ', '')
                if (val === 'Zip Code')
                    selectedField = val?.replaceAll(' ', '_')
                _field = currentOrg[selectedField]
            } else {
                selectedField = val?.replaceAll(' ', '_')
                type = typeof (selectedRowData[selectedField])
                if (type === 'object') {
                    _field = selectedRowData[selectedField]['name']
                } else if (type === 'string' || type === 'number') {
                    _field = selectedRowData[selectedField]
                }
            }
            _field = _field === undefined ? '-' : _field
            let _mt = '${' + mt + '}'
            content = content.replaceAll(_mt, _field)
        }
        // setSelectedContent(content)
        return content
    }

    const formHandler = (e) => {
        const { value } = e?.target;
        setSelectedTemplateIndex(value);
        let updatedContent = getDynamicContent(templateData?.[value]?.content)
        // //console.log('updated content:', updatedContent)
        setSelectedContent(updatedContent)
    }

    useEffect(() => {
        if (navbarList?.length) {
            // //console.log('nav list:', navbarList)
            let id = navbarList?.filter(item => item.name === 'Quotes')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList]);

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            // //console.log('sections:', sections)
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    // //console.log('dropped list:', list)
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
            if (fields) {
                // //console.log('FIELDS:', fields)
            }
        }
    })

    return (
        <>
            <Modal
                show={showPrintPreviewModal}
                onHide={() => setShowPrintPreviewModal(false)}
                backdrop="static"
                keyboard={false}
                className="modal-xl"
            >
                <Modal.Header closeButton>
                    <h4>Print Preview</h4>
                </Modal.Header>
                <Modal.Body
                    style={{ height: '600px', maxHeight: '600px', overflowY: 'scroll' }}>
                    <div className="row">
                        <div className="col-3">
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Choose Quote Template</Form.Label>
                                    <Form.Select
                                        name="selectedTemplateIndex"
                                        required
                                        value={selectedTemplateIndex}
                                        onChange={formHandler}
                                    >
                                        <option value="" disabled>None</option>
                                        {templateData && templateData.length > 0 &&
                                            templateData.map((data, index) => (
                                                <option key={data._id} value={index}>{data.templateName}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                            <div className="btn-group d-none">
                                <button type="button" className="btn btn-primary btn-blue">
                                    Print
                                </button>
                                <button type="button" className="btn btn-outline-primary btn-blue"
                                    onClick={() => setShowPrintPreviewModal(false)}
                                >Cancel</button>
                            </div>
                        </div>
                        <div className="col-9" style={{ borderLeft: '1px solid lightgrey' }}>
                            {/* <div dangerouslySetInnerHTML={{ __html: templateData?.[selectedTemplateIndex]?.content }} /> */}
                            <div dangerouslySetInnerHTML={{ __html: selectedContent }} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default PrintTemplate;